// extracted by mini-css-extract-plugin
export default {"root":"RollCall_root__wu3Pg"};